<template>
    <div class="size-full rounded-lg border flex flex-col justify-between p-[12px]">
        <div class="w-full flex items-center justify-between">
            <h2 class="flex items-center gap-x-2">Exceptions par types <Info :size="15" strokeWidth="1.3"/></h2>
            <div class="flex items-center gap-x-[12px]">
                <div class="flex items-center gap-x-2">
                    <div  class="size-5 rounded-md bg-[#3474f4]"/>
                    <span class="font-extralight">Retards</span>
                </div>
                <div class="flex items-center  gap-x-2">
                    <div  class="size-5 rounded-md bg-[#fa9832]"/>
                    <span class="font-extralight">Absences</span>
                </div>
                <div class="flex items-center gap-x-2">
                    <div class="size-5 rounded-md bg-[#24ae75]"/>
                    <span class="font-extralight">Départ anticipés</span>
                </div>
            </div>
        </div>
        <div class="w-full h-[310px] overflow-hidden">
            <apexchart type="bar" :options="options" :series="series" width="100%" height="310px"></apexchart>
        </div>
    </div>
</template>
<script>
import {Info} from "lucide-vue-next"
export default {
    name: "ExceptionCard",
    components:{Info},
    props:["datas"],
    data(){
        return {
            series: [{
                name: 'Retards',
                data: [0,0,0,0,0,0,0]
                }, {
                name: 'Départ anticipés',
                data: [0,0,0,0,0,0,0]
                }, {
                name: 'Absences',
                data: [0,0,0,0,0,0,0]
            }],
            options:{
                chart: {
                    type: 'bar',
                    animations: {
                        enabled: false
                    },
                    toolbar: {  
                    show: false
                    },
                },
                stroke: {
                    colors: ["transparent"],
                    width: 1
                },
                plotOptions: {
                bar: {
                        horizontal: false,
                        columnWidth: '88%',
                        borderRadius: 4,
                        borderRadiusApplication: 'end'
                    },
                },
                colors: ['#3474f4', '#24ae75','#fa9832'],
            xaxis: {
                categories: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi','Dimanche'],
                labels: {
                    style: {
                            fontWeight: 200,
                            colors: ['#000000']
                        },
                }
            },
            dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                }
            }
        }
    },
    mounted(){
        this.series = [{
                name: 'Retards',
                data: this.datas.r
                }, {
                name: 'Départ anticipés',
                data: this.datas.d
                }, {
                name: 'Absences',
                data: this.datas.a
            }]
    },
    methods:{
    },
}
</script>